import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import FavouriteDataItem from './FavouriteDataItem';


import { faIndustry, faUtensilSpoon } from "@fortawesome/pro-light-svg-icons";
import { faCar } from "@fortawesome/pro-light-svg-icons";
import { faIdCard } from "@fortawesome/pro-light-svg-icons";
import { faHashtag } from "@fortawesome/pro-light-svg-icons";
import { faTruck } from "@fortawesome/pro-light-svg-icons";
import { faCog } from "@fortawesome/pro-light-svg-icons";
import { faGasPump } from "@fortawesome/pro-light-svg-icons";
import { faCogs } from "@fortawesome/pro-light-svg-icons";
import { faUsers } from "@fortawesome/pro-light-svg-icons";
import { faCalendarCheck } from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { faStamp } from "@fortawesome/pro-light-svg-icons";
import { faQuoteRight } from "@fortawesome/pro-light-svg-icons";
import { faMailBulk } from "@fortawesome/pro-light-svg-icons";
import { faEuroSign } from "@fortawesome/pro-light-svg-icons";
import { faCalendarDay } from "@fortawesome/pro-light-svg-icons";

import {Test} from './Utils';

var store = require('store');

const useStyles = makeStyles(theme => ({   
    resultsRow: {        
        display:'flex',
        flexDirection: 'row',
        justifyContent:'flex-start',
        flexWrap: 'wrap',
                    
    }, 
    plateRow: {               
        marginLeft: '1em'
    }
    }));



const FavouriteData = (props) => {
    const classes = useStyles();       
    

    

    const fieldSet = props.fieldSet;
    const fieldsArray = [];             //an array of fieldPartsArray
    for (let field of fieldSet) {
        const fieldPartsArray = field.split("-");
        fieldPartsArray.shift();fieldPartsArray.shift();   //remove the first two fields in array, the first "" and "root"
        fieldsArray.push(fieldPartsArray);        
    }

 
    



    var dict = {};
    if (props.jsonObject) {        
        dict["make"] = GetField(props.jsonObject, "godkjenning", "tekniskGodkjenning", "tekniskeData", "generelt", "merke", 0, "merke")                   
        dict["model"] = GetField(props.jsonObject, "godkjenning", "tekniskGodkjenning", "tekniskeData", "generelt", "handelsbetegnelse", 0);        
        dict["plate"] = GetField(props.jsonObject, "kjoretoyId", "kjennemerke");       
        dict["vin"] = GetField(props.jsonObject, "kjoretoyId", "understellsnummer");        
        
    }



    function GetField(currentObject) {       
        try {
            for (var i=1; i < arguments.length; i++) {
                currentObject=currentObject[arguments[i]];              
            }

            return currentObject;
            
        } catch (error) {
            return "";
        }

    }

    function GetValueForDataField(fieldPartsArray) {       
        var currentObject = props.jsonObject;
        try {
            for (var fieldPart of fieldPartsArray) {               
                currentObject=currentObject[fieldPart];
            }

            return currentObject;
            
        } catch (error) {
            return "";
        }

    }

        
    const loadDisplayNamesFromLocalStorage = () => {
      var dict = {};
      if (store.get("displayNameDict"))
          dict =JSON.parse(store.get("displayNameDict"));
    
      return dict;
    }

    const displayNamesDict = loadDisplayNamesFromLocalStorage();



    function GetDisplayNameForDataField(fieldPartsArray, index) {  

      
        const dataField = [...props.fieldSet][index];
      
        if (displayNamesDict[dataField])
            return displayNamesDict[dataField];

        fieldPartsArray =  fieldPartsArray.slice();    //clone the array 
        var displayName="";
        try {
           
            for (var fieldPart of fieldPartsArray) {    
                if (isNaN(fieldPart))           
                    displayName += capitalizeFirstLetter(fieldPart) +".";
            }

            return displayName.slice(0, -1); //remove the last dot
            
        } catch (error) {
            return "";
        }

    }

    function GetIconForDataField(fieldPartsArray) {  
        
        var dict={};
        dict["merke-0-merke"] = faIndustry;
        dict["generelt-handelsbetegnelse-0"] = faCar;
        dict["kjoretoyId-kjennemerke"] = faIdCard;
        dict["drivstoffKodeMiljodata-kodeNavn"] = faGasPump;
        dict["girkassetype-kodeNavn"] = faCogs;
        dict["registreringsstatus-kodeVerdi"] = faCheckCircle;       
      
        dict["kjennemerke"] = faIdCard;
        dict["Dato"] = faCalendarDay;
        dict["Tidspunkt"] = faCalendarDay;
        dict["Forstegang"] = faCalendarDay;
        dict["Beskrivelse"] = faQuoteRight;
        dict["Id"] = faHashtag;
        dict["Referanse"] = faHashtag;
        dict["Nummer"] = faHashtag;

        
        var field="";
        for (var fieldPart of fieldPartsArray)
            field += "-" + fieldPart;

        for (var key in dict) {
            if (field.includes(key))
                return dict[key];
        }

        return faCog; //default icon            
       
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    

    return(
        
       <div>

            <div className={classes.plateRow}>{props.jsonObject && <span>Resultat for</span>} {dict["plate"]}</div>  
        
            {props.jsonObject && <div className={classes.resultsRow}>     

                                                                             
                
                    <FavouriteDataItem title='Make' value={dict["make"]} icon={faIndustry}/>
                    <FavouriteDataItem title='Model' value={dict["model"]} icon={faCar}/>
                    <FavouriteDataItem title='Reg. No' value={dict["plate"]} icon={faIdCard}/>
                    <FavouriteDataItem title='VIN' value={dict["vin"]} icon={faHashtag}/>                   

                    {
                        fieldsArray.map((fieldPartsArray, index) =>                             
                            <FavouriteDataItem key={fieldPartsArray} title={GetDisplayNameForDataField(fieldPartsArray, index)} value={GetValueForDataField(fieldPartsArray)} icon={GetIconForDataField(fieldPartsArray)}/>
                        )

                    }

                
                </div>
            }
        </div> 
    )
};

export default FavouriteData;


 